<app-section-header
    itemsName="layer"
    [totalItems]="totalAllLayers()"
    (search)="updateSearchValue($event)">
    <app-button
        [disabled]="!hasAddLayerPermissions"
        [icon]="['fas', 'add']"
        [label]="'add' | transloco"
        [tooltip]="!hasAddLayerPermissions ? ('insufficientPermissions' | transloco) : undefined"
        [type]="ButtonType.PRIMARY"
        (onClick)="openAddLayerModal()" />
</app-section-header>
<div class="flex-1 flex flex-col min-h-0 overflow-y-auto overflow-x-hidden">
    <app-expansion-panel
        class="mt-3"
        [isExpanded]="true">
        <p
            class="!m-0 text-xl"
            header>
            {{ PanelCategoriesEnum.DEPOSIT | transloco }}
            ({{ layerCountByCategory()[PanelCategoriesEnum.DEPOSIT] }})
        </p>
        <div
            class="flex-1 overflow-x-auto min-h-0"
            content>
            <app-deposit-layers-table
                [searchValue]="searchValue()"
                (updateDepositCount)="updateLayerCountByCategory($event, PanelCategoriesEnum.DEPOSIT)" />
        </div>
    </app-expansion-panel>

    <app-expansion-panel
        class="mt-3"
        [isExpanded]="false">
        <p
            class="!m-0 text-xl"
            header>
            {{ PanelCategoriesEnum.TABULAR_DEPOSIT | transloco }}
            ({{ layerCountByCategory()[PanelCategoriesEnum.TABULAR_DEPOSIT] }})
        </p>
        <div
            class="flex-1 overflow-x-auto min-h-0"
            content>
            <app-deposit-layers-table
                [geomOnly]="false"
                [searchValue]="searchValue()"
                (updateDepositCount)="updateLayerCountByCategory($event, PanelCategoriesEnum.TABULAR_DEPOSIT)" />
        </div>
    </app-expansion-panel>

    <app-expansion-panel
        class="mt-3"
        [isExpanded]="false">
        <p
            class="!m-0 text-lg font-medium"
            header>
            {{ PanelCategoriesEnum.INTERSTANDARD | transloco }}
            ({{ layerCountByCategory()[PanelCategoriesEnum.INTERSTANDARD] }})
        </p>
        <div
            class="flex-1 overflow-x-auto min-h-0"
            content>
            <app-interstandard-layers-table
                [searchValue]="searchValue()"
                (updateInterstandardItems)="updateLayerCountByCategory($event, PanelCategoriesEnum.INTERSTANDARD)" />
        </div>
    </app-expansion-panel>

    <app-expansion-panel
        class="mt-3"
        [isExpanded]="false">
        <p
            class="!m-0 text-xl"
            header>
            {{ PanelCategoriesEnum.TABULAR_INTERSTANDARD | transloco }}
            ({{ layerCountByCategory()[PanelCategoriesEnum.TABULAR_INTERSTANDARD] }})
        </p>
        <div
            class="flex-1 overflow-x-auto min-h-0"
            content>
            <app-interstandard-layers-table
                [geomOnly]="false"
                [searchValue]="searchValue()"
                (updateInterstandardItems)="
                    updateLayerCountByCategory($event, PanelCategoriesEnum.TABULAR_INTERSTANDARD)
                " />
        </div>
    </app-expansion-panel>

    <app-expansion-panel
        class="mt-3"
        [isExpanded]="false">
        <p
            class="!m-0 text-lg font-medium"
            header>
            {{ PanelCategoriesEnum.REFERENCE_DATA | transloco }}
            ({{ layerCountByCategory()[PanelCategoriesEnum.REFERENCE_DATA] }})
        </p>
        <div
            class="flex-1 overflow-x-auto min-h-0"
            content>
            <app-deposit-layers-table
                [layerType]="Layer.TypeEnum.REFERENCE_DATA"
                [searchValue]="searchValue()"
                (updateDepositCount)="updateLayerCountByCategory($event, PanelCategoriesEnum.REFERENCE_DATA)" />
        </div>
    </app-expansion-panel>

    <app-expansion-panel
        class="mt-3"
        [isExpanded]="false">
        <p
            class="!m-0 text-lg font-medium"
            header>
            {{ PanelCategoriesEnum.FLUX | transloco }}
            ({{ layerCountByCategory()[PanelCategoriesEnum.FLUX] }})
        </p>
        <div
            class="flex-1 overflow-x-auto min-h-0"
            content>
            <app-flux-layers-table
                [searchValue]="searchValue()"
                (updateFluxItems)="updateLayerCountByCategory($event, PanelCategoriesEnum.FLUX)" />
        </div>
    </app-expansion-panel>
</div>
